export const getSecretId = (ownerId, channelId) => `${ownerId}--${channelId}`

export const checkShouldRemoveOldKey = (ppKeys) => {    // Delete the old key if it's been replaced by a new one
  // Add null check to prevent "Cannot read properties of null (reading 'find')" error
  if (!ppKeys || !Array.isArray(ppKeys)) {
    return { shouldRemoveOldKey: false, oldKey: null, newKeys: [] }
  }
  
  const oldKey = ppKeys.find(({ accountId }) => accountId === '')
  const newKeys = ppKeys.filter(({ accountId }) => accountId !== '')
  // Only a real value proves the old key was replaced. Integrations whose secret is never
  // sent to the browser (e.g. Stripe) report an empty value on every row, which would
  // otherwise match every old key and hide rows the user still needs to disconnect.
  const shouldRemoveOldKey = oldKey?.privateKey
    ? newKeys.some(({ privateKey }) => privateKey === oldKey.privateKey)
    : false
  return { shouldRemoveOldKey, oldKey, newKeys }
}